// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Services
import Billing from 'services/data/billing';

// Components
import { FormCard } from 'components/content-containers/cards';
import BillingForm from 'components/models/agreement/billing-form';
import SVG from 'components/widgets/icons/svg';

// Constants


// Component
export default class AddBilling extends React.Component {
  static propTypes = {
    agreement: PropTypes.object,
    load: PropTypes.func
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { agreement, load } = this.props;
    const create = _.assign({ type: 'Fixed', agreement: agreement.id }, values);

    return Billing.create(create).then(() => load());
  }

  render() {
    const { agreement } = this.props;
    const initialValues = {};

    if (!agreement.monthly && !agreement.timeDefaultBillable) {
      initialValues.description = `${agreement.title} - [XX]%: [REASON (Agreement Signature, Stage X Completion, Project Completion)]`;
    }

    return (
      <FormCard className="billing-form">
        <div className="form-header">
          <SVG src="svg/billing.svg" className="billing" />
          <h5 className="form-title">Add Billing</h5>
        </div>
        <BillingForm
          resetOnSubmit
          initialValues={initialValues}
          onSubmit={this.onSubmit}
        />
      </FormCard>
    );
  }
}
